const SectionCont3 = () => {
	return (
		<section className="sub-content cont3">
			<div className="sub-inner">
				<div className="title-group">
					<strong className="title">경쟁사 대비 Stella의 차별화 포인트</strong>
				</div>
				<table className="table">
					<colgroup>
						<col style={{ width: 220 }} />
						<col />
						<col />
						<col />
					</colgroup>
					<thead>
						<tr>
							<th></th>
							<th>
								<strong>D사 S프로그램</strong>
								<p>회계업무에 최적화된 전문회계 시스템</p>
							</th>
							<th>
								<strong>D사 W프로그램</strong>
								<p>회계를 중심으로 전자결재 · 업무 도구를 확장할 수 있는 플랫폼</p>
							</th>
							<th>
								<strong>Stella</strong>
								<p>회계, 결재, 자금, 분석을 하나의 체계로 통합한 경영관리 시스템</p>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th scope="row">회계</th>
							<td>회계·전표·결산 중심의 핵심 회계 시스템</td>
							<td>SmartA기반 회계 모듈 제공</td>
							<td>업무 전반과 연계된 통합 회계 체계</td>
						</tr>
						<tr>
							<th scope="row">전자결재</th>
							<td>별도 시스템 필요</td>
							<td>추가 모듈</td>
							<td>
								<p className="point-color">
									유료 모듈
									<br />
									전자결재 기반 회계전표 자동 생성
								</p>
							</td>
						</tr>
						<tr>
							<th scope="row">비용</th>
							<td>User수에 따라 증가</td>
							<td>User수에 따라 증가</td>
							<td>
								<span className="point-color">월 7만원(연70만원)</span> 단일 요금
							</td>
						</tr>
						<tr>
							<th scope="row">전문가 문의 서비스</th>
							<td>없음</td>
							<td>없음</td>
							<td>
								회계·세무·법률·특허·IPO 등<br />
								다양한 전문가 서비스 제공
							</td>
						</tr>
						<tr>
							<th scope="row">거래처 신용 정보 제공</th>
							<td>없음</td>
							<td>없음</td>
							<td>업계 최초 자사·거래처 신용등급 관리 제공</td>
						</tr>
						<tr>
							<th scope="row">재고/영업 관리</th>
							<td>없음</td>
							<td>없음</td>
							<td>기본제공</td>
						</tr>
						<tr>
							<th scope="row">리포트/경영지표</th>
							<td>정형 리포트 위주</td>
							<td>기본 대시보드 수준</td>
							<td>
								사업, 금융, 인사, 재고관리 등<br />
								<span className="point-color">다양한 경영지표 Report</span> 제공
							</td>
						</tr>
					</tbody>
				</table>
				<div className="message-desc">
					<p>
						Stella는 처음부터 ‘경영관리’를 목표로 전체를 하나로 설계한 <strong>All-in-One BusinessWare</strong>입니다.
					</p>
				</div>
			</div>
		</section>
	);
};

export default SectionCont3;
